<template>
  <div
    class="group/bookmark flex items-center"
    @click.stop="onClick"
  >
    <AppIcon
      v-if="isMenuItemBookmarked(item.id)"
      class="group-hover/bookmark:hidden inline-flex p-2"
      fixed-width
      icon="fa fa-bookmark"
    />
    <AppIcon
      v-if="isMenuItemBookmarked(item.id)"
      class="hidden group-hover/bookmark:inline-flex p-2"
      fixed-width
      icon="fa fa-bookmark-slash"
    />
    <AppIcon
      v-if="!isMenuItemBookmarked(item.id)"
      class="ml-auto hidden group-hover/child:inline-flex p-2"
      fixed-width
      icon="fa-regular fa-bookmark"
    />
  </div>
</template>

<script setup lang="ts">
import { MenuItem } from "@q-food/q-food";
import { useAppSidebarStore } from "~/stores/AppSidebar";

const props = defineProps<{
  item: MenuItem;
}>();
const { item } = toRefs(props);

const { isMenuItemBookmarked, addMenuBookmark, removeMenuBookmark } =
  useAppSidebarStore();

function onClick() {
  if (isMenuItemBookmarked(item.value.id)) {
    removeMenuBookmark(item.value.id);
  } else {
    addMenuBookmark(item.value.id);
  }
}
</script>

<style scoped></style>
